import styled, { css } from 'styled-components';
import { Checkbox } from '@prosolve/common-components-ui';
import { getImplementationFieldValues, implementationCalendarFieldConfig } from './ImplementationCalendarFilters';

const COLOR_PALETTE = [
  '#2563eb', '#16a34a', '#dc2626', '#9333ea', '#ea580c', 
  '#0891b2', '#be123c', '#4f46e5', '#115e59', '#7c3aed', 
  '#ca8a04', '#0284c7', '#22c55e', '#b91c1c', '#f97316', 
  '#ec4899', '#06b6d4', '#475569', '#15803d', '#f59e0b', 
  '#84cc16', '#a21caf', '#1e3a8a', '#f472b6', '#312e81', 
  '#064e3b', '#78350f', '#4c1d95', '#0f172a', '#e11d48'
];

const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  color: #4b5563;
  font-size: 12px;

  ${({ $isMobileView }) => $isMobileView && css`
    width: 100%;
  `}
`

const OptionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
`

const hashString = (value = '') => {
  return value.split('').reduce((hash, char) => {
    return ((hash << 5) - hash) + char.charCodeAt(0);
  }, 0);
}

const getSelectedColorFields = (colorFields = {}) => {
  return implementationCalendarFieldConfig.filter(({ key }) => colorFields[key]);
}

export const getImplementationColor = (implementation, colorFields = {}) => {
  const colorKey = getSelectedColorFields(colorFields)
    .map((fieldConfig) => {
      const values = getImplementationFieldValues(implementation, fieldConfig).sort();
      return values.length > 0 ? `${fieldConfig.key}:${values.join('|')}` : '';
    })
    .filter(Boolean)
    .join('||');

  if (!colorKey) {
    return undefined;
  }

  return COLOR_PALETTE[Math.abs(hashString(colorKey)) % COLOR_PALETTE.length];
}

export default function ImplementationCalendarColorControls({
  colorFields = {},
  isMobileView,
  onChange
}) {
  const handleChange = (key) => {
    onChange({
      ...colorFields,
      [key]: !colorFields[key]
    });
  }

  return (
    <ControlsWrapper $isMobileView={isMobileView}>
      <span>Color by</span>
      <OptionsWrapper>
        {implementationCalendarFieldConfig.map(({ key, label }) => (
          <Checkbox
            key={key}
            label={label}
            value={Boolean(colorFields[key])}
            onChange={() => handleChange(key)}
          />
        ))}
      </OptionsWrapper>
    </ControlsWrapper>
  );
}
